import React, { useState } from "react";
import "./CreatePost.css";

import { storage } from "./firebase";
import { useHistory } from "react-router-dom";
import firebase from "firebase";
import {
  Button,
  FormControl,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import db from "./firebase";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 219,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
}));

const CreatePost = ({ user }) => {
  const classes = useStyles();

  const [message, setMessage] = useState("");
  const [date, setDate] = useState("");
  const [location, setLocation] = useState("");
  const [type, setType] = useState("");
  const [image, setImage] = useState(null);
  const [progress, setProgress] = useState(0);
  const [details, setDetails] = useState("");
  const history = useHistory();

  const handleFile = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const handleUpload = () => {
    if (!type || !date || !location || !message) {
      alert("please fill the form completly");
      return;
    }

    const uploadTask = storage.ref(`images/${image.name}`).put(image);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      (error) => alert(error),
      //completing function
      () => {
        storage
          .ref("images")
          .child(image.name)
          .getDownloadURL()

          .then((url) => {
            db.collection("posts").add({
              image: url,
              date: date,
              text: message,
              location: location,
              type: type,
              details: details,
              timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            });
            history.push("/");
            setImage(null);
            setProgress(0);
            setDate("");
            setType("");
            setLocation("");
            setMessage("");
            setProgress(0);
            setDetails("");
          });
      }
    );
  };

  return (
    <div>
      {!user ? (
        <div className='flex justify-center items-center text-white font-bold h-screen'>
          <p>Please Login to add post </p>
        </div>
      ) : (
        <div className='create mx-auto text-white md:p-11 xs:p-3 shadow-lg h-screen'>
          <div className='border-b-2 border-gray-400 px-2 md:mb-4 xs:mb-2 '>
            <h6 className=' font-semibold'>Details</h6>
            <p className='font-light text-gray-300 text-sm'>
              please write the details of the item you found / lost
            </p>
          </div>
          <form>
            <div className='createPost__inputs'>
              <div className='border-b-2 border-gray-400 p-1  flex justify-between items-center'>
                <span className='font-semibold'>Type</span>
                <FormControl className={`${classes.formControl} `}>
                  <Select
                    className='bg-white px-3 py-1 rounded-xl'
                    size='large'
                    onChange={(e) => setType(e.target.value)}>
                    <MenuItem value='Lost'>Lost</MenuItem>
                    <MenuItem value='Found'>Found</MenuItem>
                    <MenuItem value='News'>News</MenuItem>
                  </Select>
                </FormControl>
              </div>

              <div className='border-b-2 border-gray-400 p-2 py-3 flex justify-between items-center'>
                <span className='font-semibold'>Text</span>
                <TextField
                  autoComplete='off'
                  className='bg-white rounded-xl xs:w-56 md:w-56'
                  required
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  name='message'
                  size='small'
                  id='outlined-basic'
                  placeholder='Type your name here'
                  variant='outlined'
                />
              </div>
              <div className='border-b-2 border-gray-400 p-2 py-3  flex justify-between items-center'>
                <span className='font-semibold'>Address</span>
                <TextField
                  autoComplete='off'
                  className='bg-white placeholder-black rounded-xl xs:w-56 md:w-56'
                  required
                  size='small'
                  value={location}
                  name='location'
                  onChange={(e) => setLocation(e.target.value)}
                  id='outlined-basic'
                  placeholder='Type your address here'
                  variant='outlined'
                />
              </div>
              <div className='border-b-2 border-gray-400 p-2 py-3 flex justify-between items-center'>
                <span className='font-semibold'>Date</span>
                <TextField
                  required
                  size='small'
                  id='date'
                  value={date}
                  name='date'
                  onChange={(e) => setDate(e.target.value)}
                  type='date'
                  defaultValue='2020-05-24'
                  className={`${classes.textField} bg-white px-3 py-1 rounded-xl w-56  placeholder-color`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div className='flex flex-col p-2 mt-2 md:mb-11 xs:mb-4'>
                <h6>More Details</h6>
                <textarea
                  cols='13'
                  className='p-2 text-color mt-2'
                  rows='4'
                  placeholder='write more info on your post'
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                />
              </div>
              <div className=' flex flex-nowrap md:flex-row justify-center items-center p-2'>
                <input type='file' onChange={handleFile} />
                <progress className='progress' value={progress} max='100' />
              </div>
            </div>
            <div className='mx-auto flex justify-center mt-4 mb-3 items-center'>
              <Button
                onClick={handleUpload}
                className='py-2 px-4 bg-white text-color font-bold'>
                Post
              </Button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};
export default CreatePost;
